import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { ComponentBase } from 't4core';

@Component({
  styleUrls: ['./Items.css'],
  selector: 't4-Order-Items',
  templateUrl: './Items.html',
})
export class OrderItemComponent extends ComponentBase implements OnInit {
   constructor(el: ElementRef) {
        super();
    }


  public items: any[];
  public isLoading: boolean = false;
  public loading: boolean = false;
  public hasWritePermission: boolean = false;
  public imageDirty: boolean = false;
  public showImportItems: boolean = false;
  public files: string[] = [];
  public maxFiles = 10;
  @ViewChild("txtFile") private txtFile: ElementRef;

  async ngOnInit() {    
    await this.getItems();
    this.hasWritePermission = this.Settings.isInAny(["Admin", "BackOffice"], true);    
  }

  async getItems() {
    this.isLoading = true;
    this.items = await this.Api.get<any[]>("/TurboOrder/GetAllItems", {});
    this.isLoading = false;
  }

  async updateItem(row: any, operation: number, newValue: boolean) {
    console.log(newValue);
    //Replacment Kit
    if (operation == 1) {
      var x = await this.UI.confirm("T4.Order.Customers.Items.ReplacmentKitHeader", "Confirm replacments kit change", "T4.Order.Customers.Items.ReplacmentKitMessage", "Do you want to update the status of 'Replacment kit' for ArticleNo: {0} ?", null, [row.ArticleNo]);
      if (x) {
        row.HasReplacmentKit = newValue;
        var result = await this.updateRow(row);
        if (!result)
          row.HasReplacmentKit = !newValue;
      }
      else {
        row.HasReplacmentKit = !newValue;
      }
    }
    //Require Lock
    else if (operation == 2) {
      var x = await this.UI.confirm("T4.Order.Customers.Items.RequireLockHeader", "Confirm replacments kit change", "T4.Order.Customers.Items.RequireLockMessage", "Do you want to update the status of 'Require Lock' for ArticleNo: {0} ?", null, [row.ArticleNo]);
      if (x) {
        row.RequireLock = newValue;
        var result = await this.updateRow(row);
        if (!result)
          row.RequireLock = !newValue;
      }
      else {
        row.RequireLock = !newValue;
      }

    }
    //Require Tags
    else if (operation == 3) {
      var x = await this.UI.confirm("T4.Order.Customers.Items.RequireTagsHeader", "Confirm replacments kit change", "T4.Order.Customers.Items.RequireTagsMessage", "Do you want to update the status of 'Require Tags' for ArticleNo: {0} ?", null, [row.ArticleNo]);
      if (x) {
        row.RequireTags = newValue;
        var result = await this.updateRow(row);
        if (!result)
          row.RequireTags = !newValue;
      }
      else {
        row.RequireTags = !newValue;
      }
    }
    //Require Gps
    else if (operation == 4) {
      var x = await this.UI.confirm("T4.Order.Customers.Items.RequireGpsHeader", "Confirm replacments kit change", "T4.Order.Customers.Items.RequireGpsMessage", "Do you want to update the status of 'Require Gps' for ArticleNo: {0} ?", null, [row.ArticleNo]);
      if (x) {
        row.RequireGps = newValue;
        var result = await this.updateRow(row);
        if (!result)
          row.RequireGps = !newValue;
      }
      else {
        row.RequireGps = !newValue;
      }
    }
    //Is enabled
    else if (operation == 5) {
      var x = await this.UI.confirm("T4.Order.Customers.Items.IsEnabled", "Confirm item availability", "T4.Order.Customers.Items.IsEnabledMessage", "Do you want to update the availability status for ArticleNo: {0} ?", null, [row.ArticleNo]);
      if (x) {
        row.IsEnabled = newValue;
        var result = await this.updateRow(row);
        if (!result)
          row.IsEnabled = !newValue;
      }
      else {
        row.IsEnabled = !newValue;
      }
    }

  }

  private async updateRow(row: any) {
    var result = await this.Api.post<boolean>("TurboOrder/UpdateItem", row, {});
    if (result) {
      this.UI.snackBarLocal('T4.Order.Customers.Item.SettingUpdated', 'Settings has been updated!')
      return true;
    }
    else {
      this.UI.snackBarLocal('T4.Order.Customers.Item.SettingUpdateFail', 'Unable to update, something went wrong.')
      return false;
    }
  }

  public ImportItems() {
    this.showImportItems = true;
  }

  public beginUpload() {
    this.txtFile.nativeElement.click();
  }

  public async upload(files: FileList) {
    let me = this;

    //Do not exceed maximum files
    if ((files.length) > this.maxFiles) {
      await this.UI.alert("TO.Items.ReachedMaximumLimit", "Maximum limit reached", "TO.Items.msgReachedMaximumLimit", "You can only upload a maximum of {0} files at one time.", null, [this.maxFiles]);
      return;
    }

    for (var i = 0; i < files.length; i++) {
      var currentFile = files[i];
      let reader = new FileReader();
      reader.readAsDataURL(currentFile);
      reader.onload = async function () {
        me.loading = true;
        const name = `${currentFile.name.replace(/\.[^/.]+$/, '')}-${new Date().toISOString().replace(/[:.]/g, '-')}${currentFile.name.match(/\.[^/.]+$/)?.[0] || ''}`;
        await me.Api.post<any>("TurboOrder/ImportItems", "\"" + reader.result.toString() + "\"", { filename: name, mimeType: currentFile.type });
        me.files.push(name);
        me.loading = false;
        me.showImportItems = false;
        await me.getItems();
        await me.UI.alert("TO.Items.ImportProcessed", "Success", "TO.Items.msgImportProcessed", "The items are successfully imported to T4");
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
        me.showImportItems = false;
        me.UI.alert("TO.Items.ImportProcessedFailed", "Failed", "TO.Items.msgImportProcessesFailed", "Import items failed. Please try again later.");
      };
    }
    this.txtFile.nativeElement.value = '';

  }


}



